import { TLD } from '@peloton/app-config';
import { isBrowser } from '../../browser';
export var Country;

(function (Country) {
  Country["UnitedStates"] = "us";
  Country["UnitedKingdom"] = "gb";
  Country["Canada"] = "ca";
  Country["Germany"] = "de";
  Country["Australia"] = "au";
  Country["Default"] = "us";
})(Country || (Country = {}));

var tldCountriesMap = {
  '.com': Country.UnitedStates,
  '.co.uk': Country.UnitedKingdom,
  '.ca': Country.Canada,
  '.de': Country.Germany,
  '.com.au': Country.Australia
};
var localeCountriesMap = {
  us: Country.UnitedStates,
  gb: Country.UnitedKingdom,
  ca: Country.Canada,
  de: Country.Germany,
  au: Country.Australia
};
export var parseLocale = function parseLocale(locale) {
  return locale ? locale.replace(/^[A-z]*-/, '').toLowerCase() : '';
};
export var toCountryFromLocale = function toCountryFromLocale(locale) {
  var _localeCountriesMap;

  var key = Object.keys(localeCountriesMap).find(function (countryLocale) {
    return parseLocale(locale) === countryLocale;
  });
  return (_localeCountriesMap = localeCountriesMap[key !== null && key !== void 0 ? key : '']) !== null && _localeCountriesMap !== void 0 ? _localeCountriesMap : Country.Default;
};
/**
 * This will return Country based on App Config provided TLD, if available.
 * Falls back to `window.location.hostname`, if not.
 */

export var toCountry = function toCountry() {
  var _tldCountriesMap;

  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TLD !== null && TLD !== void 0 ? TLD : isBrowser ? window.location.hostname : '';
  var key = Object.keys(tldCountriesMap).find(function (tld) {
    return hostname.endsWith(tld);
  });
  return (_tldCountriesMap = tldCountriesMap[key !== null && key !== void 0 ? key : '']) !== null && _tldCountriesMap !== void 0 ? _tldCountriesMap : Country.Default;
};
export var parseCountry = function parseCountry(country) {
  switch (country && country.toLowerCase()) {
    case 'gb':
    case 'uk':
    case 'united kingdom':
      return Country.UnitedKingdom;

    case 'ca':
    case 'canada':
      return Country.Canada;

    case 'de':
    case 'germany':
      return Country.Germany;

    case 'au':
    case 'australia':
      return Country.Australia;

    default:
      return Country.UnitedStates;
  }
};